<top-bar-tabs></top-bar-tabs>
@if (reviewTimelineService.fund$ | async) {
  <div class="padding-container">
    <fund-information [fund]="reviewTimelineService.fund$ | async" [types]="reviewTimelineService.fundTypes$ | async" [statuses]="reviewTimelineService.statuses$ | async" [readOnly]="true"></fund-information>
    @for (category of (reviewTimelineService.outletReviewCategories$ | async); track category) {
      <timeline-tracker-section
        [items]="items$"
        [outletReviewCategory]="category"
        [outletReviewStatuses]="(reviewTimelineService.outletReviewStatuses$ | async) ?? [] "
        [outletReviewCategories]="(reviewTimelineService.outletReviewCategories$ | async) ?? []"
        [permission]="reviewTimelineService.permissions$ | async"
      [total]="total"></timeline-tracker-section>
    }
    <mat-card appearance="outlined">
      <mat-card-header>
        <mat-card-title>
          Grand Totals
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <table mat-table [dataSource]="totalItems" class="totals-table">
          <ng-container matColumnDef="blank">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef></td>
          </ng-container>
          <ng-container matColumnDef="label">
            <th mat-header-cell *matHeaderCellDef></th>
            <td colspan="4" mat-cell *matCellDef="let item">{{item.label}}</td>
          </ng-container>
          <ng-container matColumnDef="equity">
            <th mat-header-cell *matHeaderCellDef>Equity</th>
            <td mat-cell *matCellDef="let item">{{item.equity | currency: "USD" : "symbol" : "1.0" }}</td>
          </ng-container>
          <ng-container matColumnDef="percent">
            <th mat-header-cell *matHeaderCellDef>% of Gross Equity</th>
            <td mat-cell *matCellDef="let item">{{item.percentage | percent: "1.2"}}</td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="headerColumns"></tr>
          <tr mat-row *matRowDef="let row; columns:columns"></tr>
        </table>
      </mat-card-content>
    </mat-card>
  </div>
}


